import React from 'react'
import { IDistributor } from '@cbgms/api/support'
import SupportListWrapper from 'core/page/SupportListWrapper'
import N from 'utils-support/navigation'
import { getDistributors } from 'app-support/licenses/state/actions'

const DistributorOverview: React.FC = () => {
  const onAdd = () => {
    N.push('/licenses/distributors/new')
  }

  const onEdit = (data: { Distributor: IDistributor }) => {
    N.push(`/licenses/distributors/edit/${data.Distributor.UUID}`)
  }

  return (
    <SupportListWrapper
      scope='license-distributors'
      onAdd={onAdd}
      onEdit={onEdit}
      loadAction={getDistributors}
      translationKey='distributors'
    />
  )
}

export default DistributorOverview
